import { Fragment } from 'react';
import { t } from '@lingui/macro';
import { CollapsibleListItem, List, ListItemText, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useGetAllSavedViews } from 'app/domains/global-search';
import { NavItem } from './NavItem';
export function SavedViewListItem() {
    const { savedViews, loading } = useGetAllSavedViews();
    const history = useHistory();
    const path = history.location.pathname;
    const initiallyOpen = path.startsWith('/saved-view');
    if (!(savedViews === null || savedViews === void 0 ? void 0 : savedViews.length)) {
        return null;
    }
    return (<CollapsibleListItem initiallyOpen={initiallyOpen} target={<Fragment>
          <Falcon icon="layer-group"/>
          <ListItemText primary={t({
                comment: 'Saved views sidebar section text',
                message: 'Saved views',
            })}/>
          {loading && <Loader />}
        </Fragment>}>
      <List $density="small">
        {savedViews.map(savedView => (<NavItem key={savedView.id} to={`/saved-view/${savedView.id}`} matchPath={`/saved-view/${savedView.id}`}>
            <Falcon icon="layer-group"/>
            <ListItemText primary={savedView.name}/>
          </NavItem>))}
      </List>
    </CollapsibleListItem>);
}
